import { render, staticRenderFns } from "./v_Creator_Profile.vue?vue&type=template&id=652a2244&scoped=true&"
import script from "./v_Creator_Profile.vue?vue&type=script&lang=js&"
export * from "./v_Creator_Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a2244",
  null
  
)

export default component.exports